import axios from './axiosWrapper';

function unwrapFalconPayload(res) {
    const body = res?.data;
    if (body && typeof body === 'object' && 'data' in body) {
        return body.data;
    }
    return body;
}

function withUnwrappedData(promise) {
    return promise.then((res) => ({
        ...res,
        data: unwrapFalconPayload(res),
    }));
}

const CrapBulkToken = {
    createToken(payload) {
        return withUnwrappedData(axios.post('/crap/admin/bulk-token', payload));
    },
    listTokens(institutionID) {
        return withUnwrappedData(
            axios.get(`/crap/admin/bulk-token/${encodeURIComponent(String(institutionID || ''))}`)
        );
    },
    deactivateToken(tokenNumber) {
        return withUnwrappedData(
            axios.post('/crap/admin/bulk-token/deactivate', {
                tokenNumber: String(tokenNumber || '').trim().toUpperCase(),
            })
        );
    },
};

export default CrapBulkToken;
